var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalloon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3CDBF"
    },
    d: "M256,512c-4.204,0-7.611-3.407-7.611-7.611v-69.179c0-4.205,3.408-7.612,7.611-7.612 s7.611,3.407,7.611,7.612v69.179C263.611,508.593,260.205,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6473"
    },
    d: "M256,376.029c-17.422,6.879-31.079,21.229-37.021,39.102c-3.283,9.877,4.029,20.079,14.436,20.079 h45.169c10.407,0,17.72-10.203,14.436-20.079C287.079,397.257,273.422,382.908,256,376.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5368"
    },
    d: "M293.053,415.227c-5.752-17.398-18.823-31.448-35.554-38.559c-0.838,6.92-0.228,13.93,1.739,20.612 c2.217,7.527-3.288,15.094-11.135,15.094H219.98c-0.384,0.997-0.757,1.997-1.089,3.018c-3.177,9.79,4.23,19.816,14.523,19.816 h45.169C288.949,435.209,296.306,425.069,293.053,415.227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6473"
    },
    d: "M256,0c-84.075,0-152.23,68.155-152.23,152.23c0,101.665,63.077,188.598,152.23,223.799 c89.153-35.202,152.23-122.133,152.23-223.799C408.23,68.155,340.075,0,256,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0099FF"
    },
    d: "M333.774,21.352c13.557,22.763,21.352,49.356,21.352,77.774c0,79.86-38.92,150.627-98.826,194.373 c-31.549,23.038-74.432,23.446-106.069,0.527c-0.163-0.119-0.327-0.236-0.489-0.355c26.686,36.642,63.465,65.462,106.258,82.358 c89.153-35.202,152.23-122.133,152.23-223.799C408.23,96.574,378.356,47.902,333.774,21.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5368"
    },
    d: "M271.223,383.641h-30.446c-4.204,0-7.611-3.407-7.611-7.612c0-4.205,3.408-7.611,7.611-7.611h30.446 c4.204,0,7.611,3.407,7.611,7.611C278.834,380.234,275.428,383.641,271.223,383.641z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon);
export default __webpack_public_path__ + "static/media/balloon.6536a6c0f14b6c35564e10b4de411998.svg";
export { ForwardRef as ReactComponent };